import { render, staticRenderFns } from "./DateRangeDualPicker.vue?vue&type=template&id=fc120c12"
import script from "./DateRangeDualPicker.vue?vue&type=script&lang=js"
export * from "./DateRangeDualPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports